(()=>{
  const checkGuideInterval = setInterval(() => {
      const guide = document.querySelector('.ks-chart-container');      
      if (guide) {
        clearInterval(checkGuideInterval);
        guide.style.display = 'block';   
      }
    }, 500);   
})()